import { Directive, HostListener, ElementRef, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDateMask]',
})
export class DateMaskDirective {
  constructor(
    private el: ElementRef,
    @Optional() private control: NgControl,
  ) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    let input = this.el.nativeElement.value;
    if (!input) return;

    input = input.replace(/\D/g, '').substring(0, 8);

    if (input.length === 0) {
      this.updateValue('');
      return;
    }

    let day = input.substring(0, 2);
    let month = input.substring(2, 4);
    let year = input.substring(4, 8);

    if (day.length === 2) {
      if (parseInt(day, 10) === 0) day = '01';
      if (parseInt(day, 10) > 31) day = '31';
    }

    if (month.length === 2) {
      if (parseInt(month, 10) === 0) month = '01';
      if (parseInt(month, 10) > 12) month = '12';
    }

    if (day.length === 2 && month.length === 2) {
      const d = parseInt(day, 10);
      const m = parseInt(month, 10);

      if ([4, 6, 9, 11].includes(m) && d > 30) {
        day = '30';
      }

      if (m === 2) {
        if (year.length === 4) {
          const y = parseInt(year, 10);
          const isLeap = (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;
          const maxFebDays = isLeap ? 29 : 28;

          if (d > maxFebDays) {
            day = maxFebDays.toString();
          }
        } else {
          if (d > 29) {
            day = '29';
          }
        }
      }
    }

    let formatted = day;
    if (input.length > 2) {
      formatted += '/' + month;
    }
    if (input.length > 4) {
      formatted += '/' + year;
    }

    this.updateValue(formatted);
  }

  @HostListener('blur', ['$event'])
  onBlur(event: any) {
    const input = this.el.nativeElement.value;

    if (input.length !== 10) {
      this.updateValue('');
    }
  }

  private updateValue(value: string) {
    this.el.nativeElement.value = value;
    if (this.control && this.control.control) {
      this.control.control.setValue(value, { emitEvent: false });
    }
  }
}
